module.exports = __webpack_public_path__ + "static/img/9.161d625.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/9.png
// module id = aXWT
// module chunks = 1